import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 18h3v-11l6 7l6 -7v11h3","key":"svg-0"}]]

const IconCurrencyMonero = createReactComponent('outline', 'currency-monero', 'CurrencyMonero', __iconNode);

export default IconCurrencyMonero;